// extracted by mini-css-extract-plugin
export default {"button":"LinkButton_button__HTSc2 btn","link":"LinkButton_link__N-3xr LinkButton_button__HTSc2 btn"};